export const prefix = 'monitoring.course'
